export const formatSupportedChatModelName = (modelName: string) => {
  return modelName
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map(token => {
      const normalizedToken = token.toLowerCase();

      if (normalizedToken == "gpt") {
        return "GPT";
      }

      if (normalizedToken == "openai") {
        return "OpenAI";
      }

      if (normalizedToken === "claude") {
        return "Claude";
      }

      if (normalizedToken === "gemini") {
        return "Gemini";
      }

      // keeps pure numeric or decimal tokens unchanged
      if (/^\d+(\.\d+)?$/.test(token)) {
        return token;
      }

      // default case for any unknown token
      return `${token.charAt(0).toUpperCase()}${token.slice(1).toLowerCase()}`;
    })
    .join(" ");
};
